import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ServiceException, SystemMaintenanceException, VersionDeprecatedException } from '@uzurv/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// eslint-disable-next-line import/order
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration } from '../../interfaces';

@Injectable()
export class UzurvDataProcessorHttpInterceptor implements HttpInterceptor {
  constructor(@Inject(UZURV_REST_CONFIGURATION) protected uzurvRestConfiguration: UzurvRestConfiguration) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only process uzurv api requests
    if (
      !request.url.startsWith(this.uzurvRestConfiguration.claraApiUrl) &&
      !request.url.startsWith(this.uzurvRestConfiguration.dotsApiUrl)
    ) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body['errors'] && event.body['errors'].length > 0) {
            this.handleErrors(event);
          } else if (event.body) {
            if (!this.isPaginatedResponse(event.body)) {
              event = event.clone({ body: event.body['data'] });
            }
          }
        }
        return event;
      })
    );
  }

  private isPaginatedResponse(body: any): boolean {
    return (
      body !== null &&
      typeof body === 'object' &&
      'data' in body &&
      'totalElements' in body &&
      'totalPages' in body &&
      'pageSize' in body &&
      'pageNumber' in body &&
      Array.isArray(body.data)
    );
  }

  handleErrors(event: HttpResponse<any>) {
    event.body['errors'].forEach((errorMessage: string) => {
      if (errorMessage.includes('Maintenance:')) {
        throw new SystemMaintenanceException(errorMessage.replace('Maintenance:', '').trim());
      }

      if (errorMessage.includes('Deprecation:')) {
        throw new VersionDeprecatedException(errorMessage.replace('Deprecation:', '').trim());
      }
    });
    throw new ServiceException(this.extractErrorMessages(event.body['errors']));
  }

  private extractErrorMessages(errors: Array<string>): string {
    return errors.join('<br />');
  }
}
